"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));

var Styled = _styledComponents["default"].div.withConfig({
  displayName: "LoadingMore__Styled",
  componentId: "sc-66bjb-0"
})(["padding:12px 0;"]);

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "LoadingMore__StyledLabel",
  componentId: "sc-66bjb-1"
})(["margin-top:6px;font-size:12px;font-weight:600;color:", ";"], function (props) {
  var _props$theme, _props$theme$brand, _props$theme$brand$in, _props$theme$brand$in2;

  return ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$brand = _props$theme.brand) === null || _props$theme$brand === void 0 ? void 0 : (_props$theme$brand$in = _props$theme$brand.inapp) === null || _props$theme$brand$in === void 0 ? void 0 : (_props$theme$brand$in2 = _props$theme$brand$in.emptyState) === null || _props$theme$brand$in2 === void 0 ? void 0 : _props$theme$brand$in2.textColor) || "#566074";
});

var LoadingMore = function LoadingMore(_ref) {
  var noResults = _ref.noResults;
  return /*#__PURE__*/_react["default"].createElement(Styled, null, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
    size: 34,
    finished: noResults
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, "You have no more messages")));
};

var _default = LoadingMore;
exports["default"] = _default;